/**
 * Checkmark icon for completed timeline events.
 * Color: Blue (#06A4F3) for completed events
 * Size controlled by CSS: 16x16
 */
export const CheckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="12" fill="#06A4F3" />
    <path
      d="M7 12L10.5 15.5L17 9"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
